import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router';
import InsiderIcon from './png/InsiderIcon';
import {INSIDERS_LINK_CLICK_TRACKING_EVENT} from 'modules/Common/consts';
import { trackClick } from 'utils/AnalyticsUtils';
import { MetricsElement } from "react-metrics";

let linkLabel = "Insiders";

const iconProps = {
    title: linkLabel
}

export function InsiderCta({fireEventTracking, ctaBtnClasses, label, active, isMobile}) {
    require("./InsiderCta.scss");

    if (label) {
        linkLabel = label;
        iconProps.title = label;
    }

    const linkOnClick = () => {
        fireEventTracking()
    }

    iconProps.colour = !active && isMobile ? "white" : "blue";

    return (
        <Link onClick={linkOnClick} 
            {...trackClick(INSIDERS_LINK_CLICK_TRACKING_EVENT, {link: "[Insiders] Header CTA"})}
            className={ctaBtnClasses} 
            to="/insider"><InsiderIcon {...iconProps}/> 
            {linkLabel}
        </Link>
    );
}

export default function InsiderCtaWithTracking(props) {
    return (
        <div className="insider-cta">  
            <MetricsElement> 
                <InsiderCta {...props} />
            </MetricsElement>              
        </div>
    );
}

InsiderCta.propTypes = {
    fireEventTracking: PropTypes.func.isRequired,
    ctaBtnClasses: PropTypes.string.isRequired,
    label: PropTypes.string,
    active: PropTypes.bool,
    isMobile: PropTypes.bool
}


// WEBPACK FOOTER //
// ./modules/Common/components/InsiderCta.js